export default "__VITE_ASSET__9856f1e4__"